import { render, staticRenderFns } from "./TableGames.vue?vue&type=template&id=211c3967&scoped=true"
import script from "./TableGames.js?vue&type=script&lang=js&external"
export * from "./TableGames.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211c3967",
  null
  
)

export default component.exports